<template>
  <div>
    <div class="banner" :style="{backgroundImage: 'url('+banner+')'}">
      <div class="userCon">
        <h1>{{ itemData.itemName }}</h1>
        <p>{{ itemData.itemDesc }}</p>
      </div>
    </div>
    <div class="content userCon">
      <div class="left">
        <span class="title">{{ itemData.itemName }}</span>
        <div class="type">
          <div class="list" v-for="obj in subitemList" :key="obj.id"
               :style="{backgroundImage: 'url('+obj.subIcon+')'}"
               @click="change(obj.id)">
            <span class="itemName">{{ obj.subName }}</span>
            <div class="activeClass">
              <span>{{ obj.subName }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import base from "@/api/common";

export default {
  name: "systemArticle",
  data() {
    return {
      subitemList: [],
      itemData: [],
      itemId: this.$route.query.itemId,
      banner: null
    }
  },
  mounted() {
    this.getItem();
    this.getSubitemList();
  },
  methods: {
    change(id) {
      this.$router.push({path: '/articleDetail', query: {itemId: this.itemId, id: id}})
    },
    getSubitemList() {
      let that = this;
      this.$ajax.get(base.api.dict.subitem.listByItemId.replace("{itemId}", this.itemId)).then((res) => {
        if (res.data.status === 'success') {
          that.subitemList = res.data.list;
        }
      })
    },
    getItem() {
      let that = this;
      this.$ajax.get(base.api.dict.item.getById.replace("{id}", this.itemId)).then((res) => {
        if (res.data.status === 'success') {
          that.itemData = res.data.data;
          that.getBanner();
        }
      })
    },
    getBanner() {
      let that = this;
      this.$ajax.get(base.api.dict.item.getByItemCode.replace("{itemCode}", that.itemData.itemCode + "_pc_img")).then((res) => {
        if (res.data.status === 'success') {
          that.banner = res.data.data.itemIcon;
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/index_b';
</style>
